import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgChevronUp = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={46} height={46} fill="none" viewBox="0 0 46 46" {...props}><Path fill="currentColor" fillRule="evenodd" d="m46.005 32.346-23-22.846-23 22.846L4.187 36.5l18.818-18.692L41.823 36.5l4.182-4.154Z" clipRule="evenodd" /></Svg>;
const Memo = memo(SvgChevronUp);
export default Memo;